var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcSkrill = function SvgCcSkrill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 35 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#862165",
    fillRule: "evenodd",
    d: "M22.958 7.83c-.566 0-1.026.457-1.026 1.02 0 .565.46 1.021 1.026 1.021.567 0 1.026-.456 1.026-1.02 0-.564-.46-1.02-1.026-1.02ZM8.164 11.25c-.263-.017-.872-.056-.872-.601 0-.659.876-.659 1.205-.659.579 0 1.328.17 1.863.33 0 0 .298.104.551.211l.024.007V8.735l-.032-.01c-.632-.22-1.365-.43-2.726-.43C5.831 8.294 5 9.652 5 10.818c0 .67.29 2.252 2.975 2.434h.003c.23.014.83.05.83.612 0 .466-.495.74-1.327.74-.912 0-1.797-.231-2.334-.451v1.856c.804.21 1.711.314 2.774.314 2.293 0 3.321-1.286 3.321-2.56 0-1.446-1.15-2.385-3.078-2.514Zm6.924-.8.01-.028h2.456a9.357 9.357 0 0 1-1.507 2.825s1.113 1.94 1.367 2.992h-2.572s-.307-1.397-.929-2.325v2.325h-2.148V8.717l2.148-.423v4.15c.761-.915 1.1-1.8 1.175-1.995Zm12.83 5.79V8.664L30 8.295v7.944h-2.081Zm-7.174-5.897c-1.923.062-2.9.92-2.9 2.627v3.27h2.099v-2.667c0-1.021.134-1.46 1.353-1.501v-1.699c-.205-.043-.552-.03-.552-.03Zm1.174 5.896v-5.81h2.08v5.81h-2.08Zm2.963-7.574 2.08-.37v7.944h-2.08V8.665Z",
    clipRule: "evenodd"
  })));
};
export default SvgCcSkrill;